import React from 'react';
import { motion } from 'framer-motion';
import './SideMenu.css';
import { projectMeta, projectOrder } from '../projects/data';

function SideMenu({ selectedTexture, onHoverChange, side = 'left' }) {
  const items = projectOrder.map((id) => {
    const meta = projectMeta[id] || {};
    return { id, label: meta.shortTitle || meta.title || id };
  });

  const isRight = side === 'right';

  const activeIndex = items.findIndex((i) => i.id === selectedTexture);

  return (
    <div className={`side-menu ${isRight ? 'right' : 'left'}`} aria-label="Side menu">
      {items.map((item, index) => {
        const isActive = selectedTexture === item.id;
        // Distance-based falloff (closer lines are wider)
        const distance = activeIndex >= 0 ? Math.abs(index - activeIndex) : 999;
        const baseScale = 0.15;
        const falloffStep = 0.25; // 1.0, 0.75, 0.5, 0.25, then clamp to base
        const targetScaleX = Math.max(baseScale, 1.0 - distance * falloffStep);
        const targetOpacity = Math.max(0.4, 1.0 - distance * 0.15);

        return (
          <motion.div
            key={item.id}
            className="side-menu-item"
            onMouseEnter={() => onHoverChange && onHoverChange(item.id)}
            onMouseLeave={() => onHoverChange && onHoverChange('default')}
            initial={false}
          >
            <motion.div
              className={`side-menu-line ${isActive ? 'active' : ''}`}
              style={{ transformOrigin: isRight ? '100% 50%' : '0% 50%' }}
              initial={{ scaleX: baseScale, opacity: 0.6 }}
              animate={{ scaleX: targetScaleX, opacity: isActive ? 1.0 : targetOpacity }}
              whileHover={{ scaleX: 1.0, opacity: 1.0 }}
              transition={{ type: 'spring', stiffness: 240, damping: 22, mass: 0.35 }}
              title={item.label}
              role="button"
              aria-label={item.label}
            />
          </motion.div>
        );
      })}
    </div>
  );
}

export default SideMenu;


